import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  loading?: boolean;
  enterButton?: boolean | string;
  status?: "" | "error" | "warning";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Tìm kiếm..." },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    enterButton: { type: [Boolean, String], default: false },
    status: { default: "" }
  },
  emits: ["update:modelValue", "search", "blur", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onSearch = (value: string, event?: Event) => {
  emit("search", value, event);
};

const onBlur = (e: FocusEvent) => emit("blur", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!

  return (_openBlock(), _createBlock(_component_a_input_search, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    loading: _ctx.loading,
    "enter-button": _ctx.enterButton,
    status: _ctx.status,
    class: "ant-search-input",
    onSearch: onSearch,
    onBlur: onBlur
  }, null, 8, ["value", "placeholder", "disabled", "size", "allow-clear", "loading", "enter-button", "status"]))
}
}

})